export default __webpack_public_path__ + "static/media/long-arrow-right-white.53299caf.svg";